import { render, staticRenderFns } from "./PrizeDrawForm.vue?vue&type=template&id=9ffde3d8&scoped=true"
import script from "./PrizeDrawForm.vue?vue&type=script&lang=js"
export * from "./PrizeDrawForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffde3d8",
  null
  
)

export default component.exports